const pageTitle = {
  'Google Merchant Center': 'Google Merchant Center - 购物广告设定',
};

export default pageTitle;
